import { useSelector } from 'react-redux'
import { StoreState } from '@/store'
import { isEmpty } from '@/utils/is'

const useLogin = () => {
  const { userInfo } = useSelector((state: StoreState) => state.global)

  return {
    isLogin: !isEmpty(userInfo)
  }
}

export default useLogin
